import { createSlice } from "@reduxjs/toolkit";

const savedMode = localStorage.getItem("mode");

const modeSlice = createSlice({
  name: "themeMode",
  initialState: {
    mode: savedMode || "light",
  },
  reducers: {
    changeTheme: (state, action) => {
      const { mode } = action.payload;
      state.mode = mode;
      // localStorage.setItem("mode", mode);
    },
  },
});

export const { changeTheme } = modeSlice.actions;
export default modeSlice.reducer;
